import { API_ENDPOINTS } from '../config';

export const panelBigCommerceService = {
  async addToCart(panelConfig, price, imageUrl) {
    const response = await fetch(API_ENDPOINTS.PANEL_BIGCOMMERCE_CART, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        config: {
          ...panelConfig,
          ...(imageUrl ? { imageUrl } : {})
        },
        price
      })
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => null);
      throw new Error(errorData?.error || `HTTP ${response.status}: ${response.statusText}`);
    }

    return response.json();
  },

  async updateProductPhoto(productId, imageUrl, sku) {
    const response = await fetch(API_ENDPOINTS.PANEL_BIGCOMMERCE_CART, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        product_id: productId,
        image_url: imageUrl,
        sku
      })
    });

    if (!response.ok) {
      const text = await response.text();
      throw new Error(text.substring(0, 500));
    }

    return response.json();
  }
};

